// extracted by mini-css-extract-plugin
export default {"mainContent":"build-system-advanced_mainContent__e5pqu"};